import React from 'react';

import { Chip, Stack, Typography } from '@mui/material';

interface Props {
  label: string;
  value: string;
}

export default function ContextId({ label, value }: Props) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="caption" color="text.secondary" fontWeight={600}>
        {label}
      </Typography>
      <Chip
        label={value}
        size="small"
        variant="outlined"
        sx={{ fontFamily: 'monospace', bgcolor: 'grey.50', maxWidth: 260 }}
      />
    </Stack>
  );
}
